import { KostDataImportApi } from '@bindoc-projects/kost-data-import-lib/data';

export class KostDataImportDeApi extends KostDataImportApi {
  public index(): string {
    return `${this._baseUrl}/p21-imports/`;
  }

  public byId(id: string): string {
    return `${this.index()}${id}`;
  }
}
